// NOTICE: KAPTION-INTEGRATION
// partner-brand-themes.REGISTRY.1-3 / LOGIN.1-3 / SIDEBAR.1-2
// Web mirror of the server registry (kaption/app/services/kaption_brand_themes.rb).
// A theme is a logo + display name. `rumo` keeps today's assets: its `mark`
// is null so Logo.vue falls back to the installation logo exactly as before.

export const DEFAULT_BRAND_THEME = 'rumo';
export const BRAND_THEME_STORAGE_KEY = 'rumo_brand_theme';

const AUTOBIMATION_BASE = '/brand-assets/themes/autobimation';

export const BRAND_THEMES = Object.freeze({
  rumo: {
    name: 'Rumo',
    login: {
      light: '/brand-assets/logo.svg?v=rumo1',
      dark: '/brand-assets/logo_dark.svg?v=rumo1',
      // ~3:1 wordmark
      sizeClass: 'h-12',
    },
    mark: null,
  },
  autobimation: {
    name: 'Autobimation',
    login: {
      light: `${AUTOBIMATION_BASE}/logo.svg?v=1`,
      dark: `${AUTOBIMATION_BASE}/logo-dark.svg?v=1`,
      // ~6.3:1 lockup: size by width so the wordmark is not tiny, capped by
      // the viewport on phones.
      sizeClass: 'w-80 max-w-[85vw] h-auto',
    },
    mark: {
      light: `${AUTOBIMATION_BASE}/mark.svg?v=1`,
      dark: `${AUTOBIMATION_BASE}/mark-dark.svg?v=1`,
    },
  },
});

const canonical = theme =>
  String(theme ?? '')
    .trim()
    .toLowerCase();

export const isKnownBrandTheme = theme =>
  Object.prototype.hasOwnProperty.call(BRAND_THEMES, canonical(theme));

export const normalizeBrandTheme = theme =>
  isKnownBrandTheme(theme) ? canonical(theme) : DEFAULT_BRAND_THEME;

export const getBrandTheme = theme => BRAND_THEMES[normalizeBrandTheme(theme)];

// Unknown keys (a theme the server knows but this bundle does not yet) still
// get a readable label.
export const brandThemeName = theme =>
  isKnownBrandTheme(theme)
    ? BRAND_THEMES[canonical(theme)].name
    : canonical(theme).replace(
        /(^|[-_\s])(\w)/g,
        (_, sep, c) => (sep ? ' ' : '') + c.toUpperCase()
      );

export const readStoredBrandTheme = () => {
  try {
    const stored = window.localStorage.getItem(BRAND_THEME_STORAGE_KEY);
    return isKnownBrandTheme(stored) ? canonical(stored) : null;
  } catch (error) {
    return null;
  }
};

export const storeBrandTheme = theme => {
  if (!isKnownBrandTheme(theme)) return;
  try {
    window.localStorage.setItem(BRAND_THEME_STORAGE_KEY, canonical(theme));
  } catch (error) {
    // Storage blocked (private mode etc.) — the page still renders.
  }
};

// LOGIN.1-2: a known ?theme= wins and is remembered; otherwise the remembered
// theme; otherwise rumo. Unknown query values are ignored.
export const resolveLoginBrandTheme = queryTheme => {
  const fromQuery = Array.isArray(queryTheme) ? queryTheme[0] : queryTheme;
  if (isKnownBrandTheme(fromQuery)) {
    storeBrandTheme(fromQuery);
    return canonical(fromQuery);
  }
  return readStoredBrandTheme() || DEFAULT_BRAND_THEME;
};
